import React, { useState } from 'react';
import '../../css/TutorialPopupStyling.css';
import { ChevronLeft, ChevronRight, X, Circle, CircleDot } from 'lucide-react';

function TutorialPopup({ screens = [], isOpen = false, onClose, startScreen = 0, onFinish }) {
    const [currentScreen, setCurrentScreen] = useState(startScreen);

    if (!isOpen || screens.length === 0) return null;

    const goToNextScreen = () => {
        if (currentScreen < screens.length - 1) {
            setCurrentScreen(currentScreen + 1);
        }
    };

    const goToPrevScreen = () => {
        if (currentScreen > 0) {
            setCurrentScreen(currentScreen - 1);
        }
    };

    const goToScreen = (index) => {
        setCurrentScreen(index);
    };

    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    return (
        <div className="tutorial-overlay" onClick={handleOverlayClick}>
            <div className="tutorial-popup">
                {/* Close Button */}
                <button className="tutorial-close-btn" onClick={onClose} title="Close Tutorial">
                    <X size={24} color="#666" />
                </button>

                {/* Navigation Arrows */}
                <button
                    className={`tutorial-nav-btn tutorial-nav-left ${currentScreen === 0 ? 'disabled' : ''}`}
                    onClick={goToPrevScreen}
                    disabled={currentScreen === 0}
                    title="Previous Screen"
                >
                    <ChevronLeft size={32} color={currentScreen === 0 ? '#ccc' : '#666'} />
                </button>

                <button
                    className={`tutorial-nav-btn tutorial-nav-right ${currentScreen === screens.length - 1 ? 'disabled' : ''}`}
                    onClick={goToNextScreen}
                    disabled={currentScreen === screens.length - 1}
                    title="Next Screen"
                >
                    <ChevronRight size={32} color={currentScreen === screens.length - 1 ? '#ccc' : '#666'} />
                </button>

                {/* Content Area */}
                <div className="tutorial-content">
                    {screens[currentScreen]}
                </div>

                {/* Bottom Navigation */}
                <div className="tutorial-bottom-nav">
                    {/* Page Indicators */}
                    <div className="tutorial-indicators">
                        {screens.map((_, index) => (
                            <button
                                key={index}
                                className="tutorial-indicator"
                                onClick={() => goToScreen(index)}
                                title={`Go to screen ${index + 1}`}
                            >
                                {index === currentScreen ?
                                    <CircleDot size={12} color="#05B382" /> :
                                    <Circle size={12} color="#ccc" />
                                }
                            </button>
                        ))}
                    </div>

                    {/* Screen Counter */}
                    <div className="tutorial-counter">
                        {currentScreen + 1} of {screens.length}
                    </div>

                    {/* Action Buttons */}
                    <div className="tutorial-actions">
                        {currentScreen === screens.length - 1 ? (
                            <button className="tutorial-finish-btn" onClick={onFinish}>
                                Finish Tutorial
                            </button>
                        ) : (
                            <button className="tutorial-next-btn" onClick={goToNextScreen}>
                                Next
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TutorialPopup;